import {Component} from '@angular/core';
import {MachineStatus} from '@domain/machine/machine-status.enum';
import {MachineType} from '@domain/machine/machine-type.enum';
import {OverviewMachine} from '@presentation/pages/machine-overview/overview-machine';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {OverviewMachineTypeCellRendererParams} from './overview-machine-type-cell-renderer-params.interface';

@Component({
  selector: 'app-overview-machine-type.component',
  templateUrl: './overview-machine-type.component.html',
  styleUrls: ['./overview-machine-type.component.scss']
})
export class OverviewMachineTypeComponent implements ICellRendererAngularComp {
  private machine: OverviewMachine;
  private hasTexstateViewLiveStatusPermission: boolean;
  private hasTexstateViewLiveDeclarationMessagesPermission: boolean;

  public getIconNameForMachineType(): string {
    return MachineType.getIconNameForMachineType(this.machine.machineType);
  }

  public agInit(params: OverviewMachineTypeCellRendererParams): void {
    this.machine = params.data;
    this.hasTexstateViewLiveStatusPermission = params.hasTexstateViewLiveStatusPermission;
    this.hasTexstateViewLiveDeclarationMessagesPermission = params.hasTexstateViewLiveDeclarationMessagesPermission;
  }

  public refresh(params: any): boolean {
    return false;
  }

  public getStatusClass(): string {
    return MachineStatus.getMachineStatusClass(this.machine.status, this.hasTexstateViewLiveStatusPermission);
  }

  public getMachineStatusColor(): string {
    return MachineStatus.getMachineStatusColor(this.machine, this.hasTexstateViewLiveStatusPermission, this.hasTexstateViewLiveDeclarationMessagesPermission);
  }
}
